export const Dot = (props: { style?: React.CSSProperties }): JSX.Element => <span style={{ opacity: 0.2, ...props.style }}>•</span>;
